export enum Products {
    GEO = 'GEO',
    GEO_LATAM = 'GEO_LATAM',
}

export enum ProductStatus {
    ACTIVE = 'Active',
    PENDING = 'Pending',
}

export interface AssetProduct {
    product: Products;
    statusChangeDate: string;
    status: ProductStatus;
}

export interface AssetBookings {
    [key: string]: AssetProduct[];
}
